import * as React from "react";
import Svg, { Circle, Rect, SvgProps } from "react-native-svg";

function SwitchOffIcon(props: SvgProps) {
  return (
    <Svg width={55} height={30} viewBox="0 0 55 30" fill="none" {...props}>
      <Rect width={55} height={30} rx={15} fill="#ADC1C1" />
      <Circle cx={15} cy={15} r={13.75} fill="#FFFFFE" />
    </Svg>
  );
}

export default SwitchOffIcon;
